module.exports = __webpack_public_path__ + "static/media/digital.ac8f6f9a.jpeg";